
export const mrBigReviewerReviewHinge = {
  _id: 'mrBigReviewerReviewHingeId',
  email: 'mrbig@email.com',
  profileReviewId: 'mrBigProfileReviewHingeId',
  reviewerProfileId: 'mrBigReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Big! This will really help me!',
  profileReviewedFirstName: 'Carrie',
}

export const burgerReviewerReviewBumble = {
  _id: 'burgerReviewerReviewBumbleId',
  email: 'burger@email.com',
  profileReviewId: 'burgerProfileReviewBumbleId',
  reviewerProfileId: 'burgerReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Burger! This will really help me!',
  profileReviewedFirstName: 'Carrie',
}

export const aidenReviewerReviewTinder = {
  _id: 'aidenReviewerReviewTinderId',
  email: 'aiden@email.com',
  profileReviewId: 'aidenProfileReviewTinderId',
  reviewerProfileId: 'aidenReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Aiden! This will really help me!',
  profileReviewedFirstName: 'Carrie',
}